// react
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// hooks
import { useCareProfileForm } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';

// components
import { CareProfileFormPage } from '@karehero/llama/pwa/pages/CareProfileFormPage/CareProfileFormPage';
import { CareProfileCategoryID } from '@karehero/models';

/**
 * CareProfileForm is the care profile form page.
 */
export const CareProfileForm = () => {
  // hooks
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = useGoBack();
  const {
    form,
    answers,
    setAnswers,
    progress,
    handlePrintPdf,
    title,
    permission,
    trackViewed,
    handleSave,
    handleCancel,
    isSubmitting,
    sections,
  } = useCareProfileForm({ categoryID: CareProfileCategoryID.CareAssessment });

  // effects
  useEffect(trackViewed, [trackViewed]);

  return (
    <CareProfileFormPage
      title={title}
      progress={progress}
      fields={form?.fields || {}}
      value={answers}
      onChange={setAnswers}
      onBack={goBack}
      onSave={handleSave}
      onCancel={handleCancel}
      onPrint={handlePrintPdf}
      saveLabel='Continue'
      cancelLabel='Previous'
      isDisabled={!permission.isModify}
      isLoading={isSubmitting}
      sections={sections}
      currentPath={location.pathname}
      onNavigateSection={(to) => navigate(to, { replace: true })}
    />
  );
};

export default CareProfileForm;
